module.exports = {"app":{"sku":{"skuId":""},"enableCompare":true,"comparedSkus":[],"deviceClass":"l"},"metaLayer":{}}


//////////////////
// WEBPACK FOOTER
// ./client/default-state.json
// module id = 21
// module chunks = 1